import { Call, Device } from "@twilio/voice-sdk";
import { ClientEvent } from "~/modules/client/Client/ClientEvent";
import { Client } from "~/modules/client/Client/Client";
import { Action } from "~/modules/actions/Action";
import { ClientImpl } from "~/modules/client/Client/ClientImpl/ClientImpl";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { getLogger } from "~/modules/logger/LoggerFactory/getLogger";
import { LoggerName } from "~/modules/logger/Logger/LoggerName";
import { VoiceController } from "~/modules/voice/VoiceController";
import { VoiceControllerImpl } from "~/modules/voice/VoiceControllerImpl";
import { VoiceCallImpl } from "~/modules/VoiceCall";




export interface AddVoiceEventListenerOptions {
    voiceDevice?: Device;
}






















export class AddVoiceEventListener implements Action<Promise<Client>> {
    
    
    #eventName: ClientEvent;

    #listener: (...args: unknown[]) => void;

    #options?: AddVoiceEventListenerOptions;

    constructor(
        eventName: ClientEvent,
        listener: (...args: unknown[]) => void,
        options?: AddVoiceEventListenerOptions
    ) {
        this.#eventName = eventName;
        this.#listener = listener;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const client = context.retrieveInstanceOf(ContextInstance.ClientImpl, ClientImpl);
        const logger = getLogger(context)(LoggerName.Client);

        if (this.#eventName !== ClientEvent.IncomingCall) {
            logger.warn("Attempting to listen to an unknown event:", this.#eventName);
            return client as Client;
        }

        try {
            const voiceController: VoiceController = context.retrieveInstanceOf(
                ContextInstance.VoiceControllerImpl,
                VoiceControllerImpl
            );
            await voiceController.init();

            if (voiceController?.voiceDevice) {
                voiceController.voiceDevice.on(Device.EventName.Incoming, (call: Call) => {
                    const voiceCall = new VoiceCallImpl(context, call, voiceController.voiceDevice);
                    client.emitter.emit(ClientEvent.IncomingCall, voiceCall);
                });

                const newClient = client.addListener(this.#eventName, this.#listener);
                return newClient as Client;
            }

            logger.error("VoiceController does not have a voiceDevice.");
        } catch (error) {
            logger.error("Failed to add voice event listener to client.", error);
        }

        logger.warn("addVoiceEventListener failed to add a listener to the event:", this.#eventName);
        return client as Client;
    }
}
